module.exports = __webpack_public_path__ + "media/components/Sponsors/Layouts/SideMenu/messageIcon-8becb590acc58c2afa1525687bab0b89.svg";